/* eslint-disable */
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("persist", ["getTableSettings"]),
  },
  methods: {
    storedTableSettings(tableName) {
      const storedTableSettings = this.getTableSettings(tableName);
      return storedTableSettings;
    },
    storeTableSettings(tableName, settings) {
      this.$store.commit("persist/updateTableSettings", { tableName, settings });
    }
  }
};